export const ORDER_BOOK_FETCH = 'orderBook/FETCH';
export const ORDER_BOOK_DATA = 'orderBook/DATA';
export const ORDER_BOOK_ERROR = 'orderBook/ERROR';

export const DEPTH_FETCH = 'depth/FETCH';
export const DEPTH_DATA = 'depth/DATA';
export const DEPTH_DATA_INCREMENT = 'depth/DATA_INCREMENT';
export const DEPTH_DATA_SNAPSHOT = 'depth/DATA_SNAPSHOT';
export const DEPTH_ERROR = 'depth/ERROR';
export const DEPTH_INCREMENT_SUBSCRIBE = 'depth/INCREMENT_SUBSCRIBE';
